import { NON_NUMBER_PAT } from '@ott/transforms';

import flightNumberFormatter from './formatters/flightNumberFormatter';
import translateFormatter from './formatters/translateFormatter';
import applyPattern from './helpers/applyPattern';
import isOldWebkit from './helpers/isOldWebkit';

export * from './formatters/phoneNumberFormatters';

export function birthDateFormatter(value, prevValue, cursor) {
  return applyPattern(value, cursor, NON_NUMBER_PAT, (v) => (v ? '11.11.1111' : ''));
}

export function ruPassportFormatter(value, prevValue, cursor) {
  return applyPattern(value, cursor, NON_NUMBER_PAT, () => '1111-111111');
}

export function ruInternationalPassportFormatter(value, prevValue, cursor) {
  return applyPattern(value, cursor, NON_NUMBER_PAT, () => '11-1111111');
}

export const passportNumberFormatter = translateFormatter;
export { translateFormatter, applyPattern, isOldWebkit, flightNumberFormatter };
